import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDropdownContext } from '../../contexts/context.mjs';
import { dropdownFixedArea } from '../../shared/styles/fixedArea.vanilla.mjs';

const DropdownContentFooter = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const { onContentFooterElementChange } = useDropdownContext("ContentFooter");
  const className = classNames(
    dropdownFixedArea({ side: "bottom" }),
    classNameFromProps
  );
  const composedRef = useComposedRefs(
    forwardedRef,
    (element) => onContentFooterElementChange(element)
  );
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "data-scope": "dropdown",
      "data-part": "content-footer",
      className,
      ref: composedRef,
      ...props
    }
  );
});

export { DropdownContentFooter };
//# sourceMappingURL=ContentFooter.mjs.map
